export type CreateDepartmentErrorCode = 'PERMISSION_DENIED' | 'MISSING_ARGUMENT' | 'NAME_ALREADY_EXISTS' | 'UNKNOWN';

export class CreateDepartmentError extends Error {
    code: CreateDepartmentErrorCode;

    constructor(code: CreateDepartmentErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
